module.exports = __webpack_public_path__ + "img/grav.4507c37c.jpg";